// 登录
export const postAccountLogin = function (params) {
  return this.$http('post', 'account/account/login', params);
}

// qdAccountId
export const getCpaChannelByAccountId = function (params) {
  return this.$http('get', 'mall/group-info/getCpaChannelByAccountId', params);
}
